import * as Actions from './types';

const initState = {
  init: false,
  data: [],

};

const task = (state = initState, action) => {
  switch (action.type) {
    case Actions.FETCH_ONE:
      return {
        ...state,
        init: true,
        data: action.data,
      };
    default:
      return state;
  }
  switch (action.type) {
    case Actions.TASKUSER_CREATE:
      return {
        ...state,
        init: true,
        data: action.data,
      };
    default:
      return state;
  }
};
export default task;
